<script setup>
/* Menüeintrag "Spielerliste exportieren" im Konto-Menü. Erscheint nur für admin, board, data und staff
 * (canExportPlayerList); für alle anderen wird er gar nicht gerendert. Der Dialog hängt außerhalb des
 * Menüs (AccountMenu.vue), weil der Menüinhalt beim Schließen verschwindet. Die eigentliche Sperre
 * steht zusätzlich in usePlayerListExport.run — das Ausblenden hier ist nur die Oberfläche. */

import { useAuth } from '../composables/useAuth.js';
import { canExportPlayerList } from '../domain/playerListExport.js';

defineEmits(['select']);

const { role } = useAuth();
</script>

<template>
  <button v-if="canExportPlayerList(role)" class="dd-item" data-testid="export-player-list" @click="$emit('select')">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
      <path d="M12 4v11M7.5 10.5L12 15l4.5-4.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 19h14" stroke-linecap="round" />
    </svg>
    <span class="dd-label">{{ $t('playerExport.menu') }}</span>
  </button>
</template>
